import { all, call, fork, put, takeLatest } from 'redux-saga/effects'
import { ADD_UPDATE_DIAGRAM_TEMPLATE, ADD_UPDATE_DIAGRAM_TEMPLATE_SUCCESS, DELETE_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATE, DELETE_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATE_SUCCESS, ADD_UPDATE_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATE, ADD_UPDATE_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATE_ERROR, ADD_UPDATE_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATE_SUCCESS, DELETE_DIAGRAM_TEMPLATE, DELETE_DIAGRAM_TEMPLATE_SUCCESS, FETCH_DIAGRAM_TEMPLATES, FETCH_DIAGRAM_TEMPLATES_ERROR, FETCH_DIAGRAM_TEMPLATES_START, FETCH_DIAGRAM_TEMPLATES_SUCCESS, FETCH_GROUP_DIAGRAM_TEMPLATES, FETCH_GROUP_DIAGRAM_TEMPLATES_ERROR, FETCH_GROUP_DIAGRAM_TEMPLATES_SUCCESS, FETCH_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATES, FETCH_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATES_SUCCESS } from "../actions/DiagramTemplatesActions";
import { addUpdateDiagramTemplateAPI, fetchDiagramTemplatesAPI, deleteDiagramTemplateAPI, fetchPublicCategorizedDiagramTemplatesAPI, fetchGroupDiagramTemplatesAPI  } from "../../services/diagram-service";
import _ from 'lodash';
import { message } from "antd";
import { HIDE_MODAL, SUBMIT_ERROR, SUBMIT_START } from "../actions";

function* fetchDiagramTemplates({ }) {
  try {
      yield put({ type: FETCH_DIAGRAM_TEMPLATES_START });
      const response = yield call(fetchDiagramTemplatesAPI);
      if (response.success) {
          yield put({ type: FETCH_DIAGRAM_TEMPLATES_SUCCESS, diagramTemplates: _.cloneDeep(response.data) });
      } else {
          yield put({ type: FETCH_DIAGRAM_TEMPLATES_ERROR });
          message.error('Failed to fetch diagram templates!');
          message.error(response.error)
      }
  } catch (error) {
      yield put({ type: FETCH_DIAGRAM_TEMPLATES_ERROR });
      message.error(error);
  }
}

function* deleteDiagramTemplate({ payload }) {
  try {
      const response = yield call(deleteDiagramTemplateAPI, payload);
      if (response.success) {
          message.success('Diagram template deleted successully');
          yield put({ type: DELETE_DIAGRAM_TEMPLATE_SUCCESS, diagramTemplateId: _.cloneDeep(payload) });
      } else {
          message.error(response.error);
      }
  } catch (error) {
      message.error(error);
  }
}

function* addUpdateDiagramTemplate({ payload }) {
  try {
      yield put({ type: SUBMIT_START })
      const response = yield call(addUpdateDiagramTemplateAPI, payload);
      if (response.success) {
          yield put({ type: HIDE_MODAL });
          if (payload.diagramTemplateId === 0) {
              message.success('Created diagram template successully.');
          } else {
              message.success('Updated diagram template successully.');
          }

          yield put({ type: ADD_UPDATE_DIAGRAM_TEMPLATE_SUCCESS, diagramTemplate: _.cloneDeep(response.data) });
      } else {
          message.error(response.error);
          yield put({ type: SUBMIT_ERROR })
      }
  } catch (error) {
      message.error(error);
      yield put({ type: SUBMIT_ERROR })
  }
}


function* fetchPublicCategorizedDiagramTemplates({ }) {
  try {
      const response = yield call(fetchPublicCategorizedDiagramTemplatesAPI);
      console.log('response', response);
      if (response.success) {
          yield put({ type: FETCH_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATES_SUCCESS, publicCategorizedDiagramTemplates: _.cloneDeep(response.data) });
      } else {
          message.error('Failed to fetch public diagram templates!');
      }
  } catch (error) {
      message.error(error);
  }
}

function* fetchGroupDiagramTemplates({ }) {
  try {
      let response = yield call(fetchGroupDiagramTemplatesAPI);
      if (response.success) {
          yield put({ type: FETCH_GROUP_DIAGRAM_TEMPLATES_SUCCESS, groupDiagramTemplates: response.data });
      } else {
          message.error(response.error);
          yield put({ type: FETCH_GROUP_DIAGRAM_TEMPLATES_ERROR });

      }
  } catch (error) {
      message.error(error);
  }
}
function* addUpdatePublicCategorizedDiagramTemplate({ payload }) {
    try {
        yield put({ type: SUBMIT_START })
        const response = yield call(addUpdateDiagramTemplateAPI, payload);
        console.log('response', response)
        if (response.success) {
            yield put({ type: HIDE_MODAL });
            if (payload.diagramTemplateId === 0) {
                message.success('Added public diagram template successfully!');
            } else {
                message.success('Updated public diagram template successfully!');
            }
            yield put({ type: ADD_UPDATE_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATE_SUCCESS, template: response.data })
        } else {
            yield put({ type: SUBMIT_ERROR })
            if (response.error) {
                yield put({ type: ADD_UPDATE_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATE_ERROR })
                message.error(response.error);
            } else {
                yield put({ type: ADD_UPDATE_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATE_ERROR })
                message.error('Failed to save!');
            }
        }
    } catch (error) {
        yield put({ type: ADD_UPDATE_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATE_ERROR })
        message.error(error);
        yield put({ type: SUBMIT_ERROR })

    }
}

function* deleteUpdatePublicCategorizedDiagramTemplate({ payload }) {
    try {
        const response = yield call(deleteDiagramTemplateAPI, payload.diagramTemplateId);

        if (response.success) {
            message.success('Deleted diagram template successully');
            yield put({ type: DELETE_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATE_SUCCESS, template: _.cloneDeep(payload) });
        } else {
            message.error(response.error);
        }
    } catch (error) {

    }
}

export function* getDiagramTemplatesWatcher() {
  yield takeLatest(FETCH_DIAGRAM_TEMPLATES, fetchDiagramTemplates);
  yield takeLatest(DELETE_DIAGRAM_TEMPLATE, deleteDiagramTemplate);
  yield takeLatest(ADD_UPDATE_DIAGRAM_TEMPLATE, addUpdateDiagramTemplate);
 yield takeLatest(FETCH_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATES, fetchPublicCategorizedDiagramTemplates);
 yield takeLatest(ADD_UPDATE_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATE, addUpdatePublicCategorizedDiagramTemplate);
 yield takeLatest(DELETE_PUBLIC_CATEGORIZED_DIAGRAM_TEMPLATE, deleteUpdatePublicCategorizedDiagramTemplate);
 yield takeLatest(FETCH_GROUP_DIAGRAM_TEMPLATES, fetchGroupDiagramTemplates);
}



export default function* rootSaga() {
  yield all([fork(getDiagramTemplatesWatcher),
  ]);
}